import { createStore } from 'vuex'

export default createStore({
  state: {
    mostrarValidacion:true,
    mostrarDesafio:false,
    mostrarOpps:false,
    mostrarFelicitaciones:false,
    mostrarDesafioExclusivo:false,
    mostrarYaRegistrado:false,
    mostrarFinalizado:false,
    mostrarAvance:false,
    mostrarNoRegistrado:false,
    idCliente:'',
    email:'',
    telefono:'',
    origen:'',
    id1:'',
    id2:'',
    id3:'',
    visita1:'',
    visita2:'',
    visita3:'',
    cantidad1:'',
    cantidad2:'',
    cantidad3:'',
    metas:[],
    data:[],
    nombre:'',
  },
  actions:{
    setOrigen({commit},origen){
      commit("SET_ORIGEN",origen);
    },
    setMostrarValidacion({commit},mostrarValidacion){
      commit("SET_MOSTRAR_VALIDACION",mostrarValidacion);
    },
    setMostrarDesafio({commit},mostrarDesafio){
      commit("SET_MOSTRAR_DESAFIO",mostrarDesafio);
    },
    setMostrarOpps({commit},mostrarOpps){
      commit("SET_MOSTRAR_OPPS",mostrarOpps);
    },
    setMostrarAvence({commit},mostrarAvance){
      commit("SET_MOSTRAR_AVANCE",mostrarAvance);
    },
    setMostrarFelicitaciones({commit},mostrarFelicitaciones){
      commit("SET_MOSTRAR_FELICITACIONES",mostrarFelicitaciones);
    },
    setMostrarDesafioExclusivo({commit},mostrarDesafioExclusivo){
      commit("SET_MOSTRAR_DESAFIO_EXCLUSIVO",mostrarDesafioExclusivo);
    },
    setMostrarYaRegistrado({commit},mostrarYaRegistrado){
      commit("SET_MOSTRAR_YA_REGISTRADO",mostrarYaRegistrado);
    },
    setMostrarNoRegistrado({commit},mostrarNoRegistrado){
      commit("SET_MOSTRAR_NOREGISTRADO",mostrarNoRegistrado);
    },
    setMostrarFinalizado({commit},mostrarFinalizado){
      commit("SET_MOSTRAR_FINALIZADO",mostrarFinalizado);
    },
    setIdCliente({commit},idCliente){
      commit("SET_ID_CLIENTE",idCliente);
    },
    setMetas({commit},metas){
      commit("SET_METAS",metas);
    },
    setData({commit},data){
      commit("SET_DATA",data);
    },
    setNombre({commit},nombre){
      commit("SET_NOMBRE",nombre);
    },
  },
  mutations: {
    SET_ORIGEN(state, origen){
      state.origen= origen;
    },
    SET_MOSTRAR_VALIDACION(state, mostrarValidacion){
      state.mostrarValidacion= mostrarValidacion;
    },
    SET_MOSTRAR_DESAFIO(state, mostrarDesafio){
      state.mostrarDesafio= mostrarDesafio;
    },
    SET_MOSTRAR_OPPS(state, mostrarOpps){
      state.mostrarOpps= mostrarOpps;
    },
    SET_MOSTRAR_NOREGISTRADO(state, mostrarNoRegistrado){
      state.mostrarNoRegistrado= mostrarNoRegistrado;
    },
    SET_MOSTRAR_AVANCE(state, mostrarAvance){
      state.mostrarAvance= mostrarAvance;
    },
    SET_MOSTRAR_FELICITACIONES(state, mostrarFelicitaciones){
      state.mostrarFelicitaciones= mostrarFelicitaciones;
    },
    SET_MOSTRAR_DESAFIO_EXCLUSIVO(state, mostrarDesafioExclusivo){
      state.mostrarDesafioExclusivo= mostrarDesafioExclusivo;
    },
    SET_MOSTRAR_YA_REGISTRADO(state, mostrarYaRegistrado){
      state.mostrarYaRegistrado= mostrarYaRegistrado;
    },
    SET_MOSTRAR_FINALIZADO(state, mostrarFinalizado){
      state.mostrarFinalizado= mostrarFinalizado;
    },
    SET_ID_CLIENTE(state, idCliente){
      state.idCliente= idCliente;
    },
    SET_METAS(state, metas){
      state.metas= metas;
    },
    SET_DATA(state, data){
      state.data= data;
    },

    SET_NOMBRE(state, nombre){
      state.nombre= nombre;
    },
  }
})
